import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../Admin/Admin.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import Workflows from './Workflows';
import WorkflowTasks from './WorkflowTasks';

class WorkflowContainer extends Component {
    constructor(props) {
        super(props);
        this.blankWorkflow = {
            id: 0,
            name: '',
            description: '',
            duration: 0,
            order: 0,
            completionBusinessDays: '',
            morningProcess: false,
            automated: false,
            timeTarget: '',
            active: true,
            deleted: false,
            workflowTasks: []
        }
        this.blankWorkflowTask = {
            id: 0,
            name: '',
            description: '',
            order: 0,
            duration: 0,
            completionBusinessDays: '',
            morningProcess: false,
            automated: false,
            timeTarget: '',
            active: true,
            deleted: false,
            workflows: []
        }
        this.state = {
            workflows: [],
            workflowId: 0,
            workflowTasks: [],
            editWorkflow: { ...this.blankWorkflow },
            editWorkflowTask: { ...this.blankWorkflowTask },
            newWorkflow: { ...this.blankWorkflow },
            newWorkflowTask: { ...this.blankWorkflowTask },
            isLoaded: false,
        };
    }

    componentDidMount() {
        this.props.log('WorkflowContainer.js/componentDidMount');
        this.getWorkflows();
    }

    getWorkflows = () => {
        this.props.log('WorkflowContainer.js/getWorkflows');
        fetch('/api/workflows/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        workflows: results.workflows,
                        workflowTasks: results.workflowTasks,
                        isLoaded: true
                    });
                } else {
                    this.props.addToast('Unable to load workflows.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditWorkflow = (id) => {
        this.props.log('WorkflowContainer.js/onEditWorkflow (id)', id);
        const workflow = [...this.state.workflows].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editWorkflow: {
                    id: workflow.id,
                    name: workflow.name,
                    description: workflow.description,
                    duration: workflow.duration,
                    completionBusinessDays: workflow.completionBusinessDays,
                    order: workflow.order,
                    morningProcess: workflow.morningProcess,
                    automated: workflow.automated,
                    timeTarget: workflow.timeTarget,
                    active: workflow.active,
                    deleted: workflow.deleted,
                    workflowTasks: workflow.tasks != null ? workflow.tasks : [],
                    workflowClients: workflow.clients != null ? workflow.clients : []
                    // workflowTasks: [...this.state.workflowTasks].filter(workflowTask => workflowTask.workflows.findIndex(i => i.id === id) > -1).map(workflowTask => { return { id: workflowTask.id, order: workflowTask.order } })
                }
            }
        })
    }

    onCopyWorkflow = (id) => {
        this.props.log('WorkflowContainer.js/onCopyWorkflow (id)', id);
        const workflow = [...this.state.workflows].filter(item => item.id === id)[0];
        let newOrder = Math.max(...this.state.workflows.map(i => i['order']), 0) + 10;
        this.setState(() => {
            return {
                editWorkflow: { ...this.blankWorkflow },
                newWorkflow: {
                    // id: workflow.id,
                    name: 'Copy of ' + workflow.name,
                    description: workflow.description != null ? workflow.description : '',
                    duration: workflow.duration != null ? workflow.duration : '',
                    completionBusinessDays: workflow.completionBusinessDays != null ? workflow.completionBusinessDays : '',
                    order: newOrder,
                    morningProcess: workflow.morningProcess,
                    automated: workflow.automated,
                    timeTarget: workflow.timeTarget,
                    active: workflow.active,
                    deleted: workflow.deleted,
                    // workflowTasks: workflow.tasks != null ? workflow.tasks : [],
                    // workflowClients: workflow.clients != null ? workflow.clients : []
                    // workflowTasks: [...this.state.workflowTasks].filter(workflowTask => workflowTask.workflows.findIndex(i => i.id === id) > -1).map(workflowTask => { return { id: workflowTask.id, order: workflowTask.order } })
                }
            }
        })
    }

    onDeleteWorkflow = (id) => {
        this.props.log('WorkflowContainer.js/onDeleteWorkflow(id)', id);
        fetch('/api/workflows/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getWorkflows();
                    this.props.addToast('Workflow deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete workflow.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeWorkflow = (e, type) => {
        this.props.log('WorkflowContainer.js/onChangeWorkflow (e, type)', e, type);
        e.persist();
        let thisWorkflow = (type === 'edit') ? this.state.editWorkflow : this.state.newWorkflow;
        switch (e.target.name) {
            case "active":
            case "morningProcess":
            case "automated":
                thisWorkflow[e.target.name] = !thisWorkflow[e.target.name];
                break;
            case "workflowTasks":
                const id = parseInt(String(e.target.id).split('_')[1]);
                const index = thisWorkflow.workflowTasks.findIndex(item => item.id === id);
                if (index > -1) thisWorkflow.workflowTasks.splice(index, 1);
                if (e.target.checked) thisWorkflow.workflowTasks.push({ id: id, order: 10000 });
                break;
            case "workflowClients":
                const id2 = parseInt(String(e.target.id).split('_')[1]);
                const index2 = thisWorkflow.workflowClients.findIndex(item => item.id === id2);
                if (index2 > -1) thisWorkflow.workflowClients.splice(index2, 1);
                if (e.target.checked) thisWorkflow.workflowClients.push({ id: id2 });
                break;
            default:
                thisWorkflow[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editWorkflow: thisWorkflow } : { newWorkflow: thisWorkflow };
        });
    }

    handleCancelWorkflow = () => {
        this.props.log('WorkflowContainer.js/handleCancelWorkflow');
        this.setState({
            editWorkflow: { ...this.blankWorkflow },
        })
    }

    handleAddWorkflow = (e) => {
        this.props.log('WorkflowContainer.js/handleAddWorkflow');
        let newOrder = Math.max(...this.state.workflows.map(i => i['order']), 0) + 10;
        fetch('/api/workflows/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newWorkflow.name,
                description: this.state.newWorkflow.description,
                duration: this.state.newWorkflow.duration,
                completionBusinessDays: this.state.newWorkflow.completionBusinessDays,
                order: newOrder,
                active: this.state.newWorkflow.active,
                morningProcess: this.state.newWorkflow.morningProcess,
                automated: this.state.newWorkflow.automated,
                timeTarget: this.state.newWorkflow.timeTarget
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newWorkflow: { ...this.blankWorkflow },
                    }, () => this.getWorkflows());
                    this.props.addToast('Workflow added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add workflow.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditWorkflow = () => {
        this.props.log('WorkflowContainer.js/handleEditWorkflow');
        fetch('/api/workflows/' + this.state.editWorkflow.id, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editWorkflow.name,
                description: this.state.editWorkflow.description,
                duration: this.state.editWorkflow.duration,
                completionBusinessDays: this.state.editWorkflow.completionBusinessDays,
                order: this.state.editWorkflow.order,
                morningProcess: this.state.editWorkflow.morningProcess,
                automated: this.state.editWorkflow.automated,
                timeTarget: this.state.editWorkflow.timeTarget,
                active: this.state.editWorkflow.active,
                deleted: this.state.editWorkflow.deleted,
                workflowTasks: this.state.editWorkflow.workflowTasks,
                workflowClients: this.state.editWorkflow.workflowClients
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editWorkflow: { ...this.blankWorkflow },
                        editWorkflowTask: { ...this.blankWorkflowTask }
                    }, () => this.getWorkflows());
                    this.props.addToast('Workflow updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update workflow.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeWorkflowTask = (e, type) => {
        this.props.log('WorkflowContainer.js/onChangeWorkflowTask (e,type)', e, type);
        e.persist();
        let thisWorkflowTask = (type === 'edit') ? this.state.editWorkflowTask : this.state.newWorkflowTask;
        switch (e.target.name) {
            case "active":
            case "morningProcess":
            case "automated":
                thisWorkflowTask[e.target.name] = !thisWorkflowTask[e.target.name];
                break;
            case "workflows":
                const id = parseInt(String(e.target.id).split('_')[1]);
                const index = thisWorkflowTask.workflows.findIndex(item => item.id === id);
                if (index > -1) thisWorkflowTask.workflows.splice(index, 1);
                if (e.target.checked) thisWorkflowTask.workflows.push({ id: id, order: 10000 });
                break;
            default:
                thisWorkflowTask[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editWorkflowTask: thisWorkflowTask } : { newWorkflowTask: thisWorkflowTask };
        });
    }

    onEditWorkflowTask = (id) => {
        this.props.log('WorkflowContainer.js/onEditWorkflowTask (id)', id);
        const workflowTask = [...this.state.workflowTasks].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editWorkflowTask: {
                    id: id,
                    name: workflowTask.name,
                    description: workflowTask.description,
                    order: workflowTask.order,
                    duration: workflowTask.duration,
                    completionBusinessDays: workflowTask.completionBusinessDays,
                    active: workflowTask.active,
                    morningProcess: workflowTask.morningProcess,
                    automated: workflowTask.automated,
                    timeTarget: workflowTask.timeTarget,
                    workflows: [...this.state.workflows].filter(workflow => workflow.tasks.findIndex(i => i.id === id) > -1).map(workflow => { return { id: workflow.id, order: workflow.order } })
                }
            }
        })
    }

    onCopyWorkflowTask = (id) => {
        this.props.log('WorkflowContainer.js/onCopyWorkflowTask (id)', id);
        const workflowTask = [...this.state.workflowTasks].filter(item => item.id === id)[0];
        let newOrder = Math.max(...this.state.workflowTasks.map(i => i['order']), 0) + 10;
        this.setState(() => {
            return {
                editWorkflowTask: { ...this.blankWorkflowTask },
                newWorkflowTask: {
                    // id: workflow.id,
                    name: 'Copy of ' + workflowTask.name,
                    description: workflowTask.description != null ? workflowTask.description : '',
                    duration: workflowTask.duration != null ? workflowTask.duration : '',
                    completionBusinessDays: workflowTask.completionBusinessDays != null ? workflowTask.completionBusinessDays : '',
                    order: newOrder,
                    morningProcess: workflowTask.morningProcess,
                    automated: workflowTask.automated,
                    timeTarget: workflowTask.timeTarget,
                    active: workflowTask.active,
                    deleted: workflowTask.deleted,
                    // workflowTasks: workflow.tasks != null ? workflow.tasks : [],
                    // workflowClients: workflow.clients != null ? workflow.clients : []
                    // workflowTasks: [...this.state.workflowTasks].filter(workflowTask => workflowTask.workflows.findIndex(i => i.id === id) > -1).map(workflowTask => { return { id: workflowTask.id, order: workflowTask.order } })
                }
            }
        })
    }

    onDeleteWorkflowTask = (id) => {
        this.props.log('WorkflowContainer.js/onDeleteWorkflowTask (id)', id);
        fetch('/api/workflow-tasks/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getWorkflows();
                    this.props.addToast('Workflow task deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete workflow task.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancelWorkflowTask = () => {
        this.props.log('WorkflowContainer.js/handleCancelWorkflowTask');
        this.setState({
            editWorkflowTask: { ...this.blankWorkflowTask },
        })
    }

    handleEditWorkflowTask = () => {
        this.props.log('WorkflowContainer.js/handleEditWorkflowTask');
        fetch('/api/workflow-tasks/' + this.state.editWorkflowTask.id, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editWorkflowTask.name,
                description: this.state.editWorkflowTask.description,
                order: this.state.editWorkflowTask.order,
                duration: this.state.editWorkflowTask.duration,
                completionBusinessDays: this.state.editWorkflowTask.completionBusinessDays,
                active: this.state.editWorkflowTask.active,
                morningProcess: this.state.editWorkflowTask.morningProcess,
                automated: this.state.editWorkflowTask.automated,
                timeTarget: this.state.editWorkflowTask.timeTarget,
                workflows: this.state.editWorkflowTask.workflows
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editWorkflow: { ...this.blankWorkflow },
                        editWorkflowTask: { ...this.blankWorkflowTask }
                    }, () => this.getWorkflows());
                    this.props.addToast('Workflow task updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update workflow task.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAddWorkflowTask = (e) => {
        this.props.log('WorkflowContainer.js/handleAddWorkflowTask');
        let newOrder = Math.max(...this.state.workflowTasks.map(i => i['order']), 0) + 10;
        fetch('/api/workflow-tasks/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newWorkflowTask.name,
                description: this.state.newWorkflowTask.description,
                order: newOrder,
                duration: this.state.newWorkflowTask.duration,
                completionBusinessDays: this.state.newWorkflowTask.completionBusinessDays,
                active: this.state.newWorkflowTask.active,
                morningProcess: this.state.newWorkflowTask.morningProcess,
                automated: this.state.newWorkflowTask.automated,
                timeTarget: this.state.newWorkflowTask.timeTarget
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newWorkflowTask: { ...this.blankWorkflowTask }
                    }, () => this.getWorkflows());
                    this.props.addToast('Workflow task added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add workflow task.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    setDragTarget = (workflowId) => {
        this.props.log('WorkflowContainer.js/setDragTarget (workflowId)', workflowId);
        this.setState({
            // editWorkflow: workflowId == null ? this.blankWorkflow : this.state.editWorkflow,
            // editWorkflowTask: 
            workflowId: workflowId
        })
    }

    reorder = () => {
        this.props.log('WorkflowContainer.js/reorder()');
        let dbWorkflows = [];
        let dbWorkflowTasks = [];
        let data = [...this.state.workflows];
        data = data.map((workflow, workflowIndex) => {
            let tasks = [...this.state.editWorkflow.workflowTasks].filter(task => task != null);
            tasks = tasks.map((task, taskIndex) => {
                if (task && dbWorkflowTasks.findIndex(item => item.id === task.id) === -1)
                    dbWorkflowTasks.push({ id: task.id, order: (taskIndex + 1) * 10 })
                return { ...task, order: (taskIndex + 1) * 10 }
            });
            if (dbWorkflows.findIndex(item => item.id === workflow.id) === -1) dbWorkflows.push({ id: workflow.id, order: (workflowIndex + 1) * 10 })
            return { ...workflow, order: (workflowIndex + 1) * 10, tasks: tasks }
        })
        this.setState({ workflows: data }, () => {
            fetch('/api/workflows-order/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify(
                    { workflows: dbWorkflows, tasks: dbWorkflowTasks }
                )
            }, () => this.getWorkflows())
        });
    }

    render() {
        this.props.info('WorkflowContainer.js/render');
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                if (this.state.workflowId == null) {
                    const data = [...this.state.workflows];
                    const item = data.splice(fromIndex, 1)[0];
                    data.splice(toIndex, 0, item);
                    this.setState({ workflows: data }, () => this.reorder());
                } else {
                    const workflowIndex = this.state.workflows.findIndex(workflow => workflow.id === this.state.workflowId);
                    const data = [...this.state.workflows];
                    const tasksData = [...this.state.workflows][workflowIndex].tasks;
                    const item = tasksData.splice(fromIndex, 1)[0];
                    tasksData.splice(toIndex, 0, item);
                    data[workflowIndex].tasks = tasksData;
                    this.setState({
                        workflows: data,
                        editWorkflow: { ...this.state.editWorkflow, workflowTasks: tasksData.map((item, index) => { return { id: item.id, order: (index + 1) * 10 } }) }
                    }, () => this.reorder());
                }
            },
            nodeSelector: 'div.workflowRow',
            handleSelector: 'span.dragIcon'
        };

        return (
            (this.state.isLoaded) ?
                <>
                    <CollapseCard title="Workflows Management" open={true}>
                        <Workflows
                            {...this.props}
                            workflows={this.state.workflows}
                            workflowTasks={this.state.workflowTasks}
                            newWorkflow={this.state.newWorkflow}
                            editWorkflow={this.state.editWorkflow}
                            dragProps={dragProps}
                            onChange={this.onChangeWorkflow}
                            onEdit={this.onEditWorkflow}
                            onCopy={this.onCopyWorkflow}
                            onDelete={this.onDeleteWorkflow}
                            handleAdd={this.handleAddWorkflow}
                            handleEdit={this.handleEditWorkflow}
                            handleCancel={this.handleCancelWorkflow}
                            setDragTarget={this.setDragTarget}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                    <CollapseCard title="Workflow Tasks" open={true}>
                        <WorkflowTasks
                            {...this.props}
                            workflows={this.state.workflows}
                            workflowTasks={this.state.workflowTasks}
                            newWorkflowTask={this.state.newWorkflowTask}
                            editWorkflowTask={this.state.editWorkflowTask}
                            onChange={this.onChangeWorkflowTask}
                            onEdit={this.onEditWorkflowTask}
                            onCopy={this.onCopyWorkflowTask}
                            onDelete={this.onDeleteWorkflowTask}
                            handleAdd={this.handleAddWorkflowTask}
                            handleEdit={this.handleEditWorkflowTask}
                            handleCancel={this.handleCancelWorkflowTask}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default WorkflowContainer;
